import endSearchSession from '../actions/endSearchSession';
import endSearchSessionService from '../services/endSearchSessionService';
import setIsSearchHistoryDirty from '../actions/setIsSearchHistoryDirty';
import shallowClearSearchStore from '../actions/shallowClearSearchStore';
import updateSearchHistoryUserConfig from '../services/updateSearchHistoryUserConfig';
import { getStore as getSearchStore } from '../store/Store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { lazylogSessionEnd } from '../index';
import { orchestrator } from 'satcheljs';

export default orchestrator(
    endSearchSession,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
     * See aka.ms/mini-lint-errors
     *	> 'actionMessage' is defined but never used. */
    async function endSearchSessionOrchestrator(actionMessage: {}) {
        const searchStore = getSearchStore();
        const { searchSessionGuid, latestTraceId, isSearchHistoryDirty } = searchStore;
        if (!searchSessionGuid) {
            return;
        }

        shallowClearSearchStore();

        if (isMiniFeatureEnabled('mini-suggestionsQF')) {
            if (isSearchHistoryDirty) {
                updateSearchHistoryUserConfig();
                setIsSearchHistoryDirty(false);
            }

            // Log 'sessionend' if QF flight is enabled
            (await lazylogSessionEnd.import())(latestTraceId, new Date());
        }

        endSearchSessionService(searchSessionGuid);
    }
);
